
  import { Component, Prop, Watch } from 'vue-property-decorator';
  import Vue from 'vue';
  import { Bar } from 'vue-chartjs'
    import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
    } from 'chart.js'

  import Chart from 'chart.js/auto';
  import { IFileCountDashboardResource } from '@/types/resource.types';
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)
  
  @Component({
      name: 'FileCountGraph',
      components: {
        Bar,
        ChartJS
      }
  })
  
  
  export default class FileCountGraph extends Vue {

    /* Props
    ============================================*/
      @Prop({type: Object, required: true})
      readonly fileCountDashboard: IFileCountDashboardResource;
      
    
    randomIterator: number = 0;
    chart: Chart | null;
    chartOpt: Object = {
          responsive: true,
            plugins:{
                legend: {
                display: false
            }},
          maintainAspectRatio: false,
            x: {
                beginAtZero: true
            },
            y: {
                beginAtZero: true
            },
            tooltips: {
                displayColors:false
            }
        };
    /* Data
    ============================================*/
  myStyles: object = {
        height: '100%',
        width: '100%',
        position: 'relative'
      };
  
    /* Computed
    ============================================*/
    get menuCollapsed(){
      return this.$store?.state?.menuIsCollapsed;
    }
    get chartOptions() {
        return {
          responsive: true,
            plugins:{
                legend: {
                display: false
            }},
          maintainAspectRatio: false,
            x: {
                beginAtZero: true
            },
            y: {
                beginAtZero: true
            }
        };
    }
    chartPlugins() {
        return {
            legend: {
                display: false,
                toggle: false
            }       
        };
    }
    color(format : string){
        switch(format){
            case "Total":
                return "#001b78";
            case "jpg":
                return "#00b159";
            case "3gp":
                return "#d11141";
            case "asf":
                return "#00aedb";
            case "avi":
                return "#f37735";
            case "m4a":
                return "#ffc425";
            case "m4v":
                return "#9467bd";
            case "mov":
                return "#1f77b4";
            case "mp4":
                return "#7f7f7f";
            case "mpg":
                return "#2ca02c";
            case "heic":
                return "#ff69b4";
            case "png":
                return "#17becf";
        }

        return this.getRandomColor();
    }

    getRandomColor(){
        let colors = [
            "#e377c2",
            "#7f7f7f",
            "#bcbd22",
            "#17becf",
            "#ff7f0e",
            "#6a3d9a",
            "#b15928",
            "#393b79",
            "#5254a3",
            "#637939",
        ];
        if(this.randomIterator > colors.length) return "#ffffff";
        return colors[this.randomIterator];
    }
    get chartData(){
        var data = [];
        var labels = [];

        if(this.fileCountDashboard){
            let thisDataset = this.fileCountDashboard.datasets[0];
            data.push({
                    data: thisDataset.data,
                    label: "Files Submitted",
                    backgroundColor: "#00b159"
                });
            return {
                labels: this.fileCountDashboard.monthLabels,
                datasets: data
                }
        }
        return {labels:[], datasets:[]};
    }
    
  }
  
  
  